<template>
  <SogButton
    ref="obj"
    class="sog-card-action-button"
    :type="SogButtonType.Card"
    :disabled="disabled"
    :mdi-icon="mdiIcon"
    :e-icon="eIcon"
    :tooltip="tooltip"
    :kind="kind"
    :svg-icon="svgIcon"
    style="align-self: flex-end"
    :button-style="buttonStyle"
    @click="$emit('click')"
  >
    <slot />
  </SogButton>
</template>

<script setup lang="ts">
import {ref} from "vue";
import SogButton from "@/shared/ui/SogButton.vue";
import {SogButtonKind} from "@/shared/ui/types/SogButtonKind";
import {SogButtonType} from "@/shared/ui/types/SogButtonType";
import {SogButtonStyle} from "@/shared/ui/types/SogButtonStyle";

defineEmits(['click'])

interface Props {
  mdiIcon?: string
  disabled?: boolean | string
  eIcon?: string
  svgIcon?:string
  tooltip?: string
  kind?:SogButtonKind,
  buttonStyle?:SogButtonStyle
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(), {
  mdiIcon: "", disabled: false, eIcon: undefined, tooltip: undefined,kind : SogButtonKind.Default,svgIcon:undefined,buttonStyle:SogButtonStyle.Default

  }
)

const obj = ref<InstanceType<typeof SogButton>  | null>(null)

const focus = ()=>{
  obj.value?.focus();
}

defineExpose({
  focus
})


</script>

<style scoped>

.sog-card-action-button:disabled{
  cursor: default;
  background-color: #1f2937;
  border-color: #374151;
  box-shadow: none;
  color: #6b7280;
}

</style>
